import { sellerOpportunities } from '@backmarket/http-api'
import { useHttpFetch } from '@backmarket/nuxt-module-http/useHttpFetch'

const DEFAULT_VALUE = {
  categoryFilterOptions: [],
  gradeFilterOptions: [],
  currencyFilterOptions: [],
  competitionFilterOptions: [],
} as sellerOpportunities.GetInventoryOpportunitiesMetadata

export function useMetadata() {
  const { data: metadata } = useHttpFetch(
    sellerOpportunities.getInventoryOpportunitiesMetadata,
    { default: () => DEFAULT_VALUE },
  )

  return {
    metadata,
  }
}
